import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    testimonials: [],
    faqList: [],
    isError: false,
    isSSR: false
};

export const fetchDataSuccess = (state = INITIAL_STATE, { testimonials, faqList }) => {
    return { ...state, testimonials, faqList };
};

export const fetchDataFailure = (state = INITIAL_STATE) => {
    return { ...state, isError: true };
};

export const setDetails = (state = INITIAL_STATE, { data }) => {
    return { ...state, ...data };
};

export const setIsSsr = (state = INITIAL_STATE, { isSsr }) => {
    return { ...state, isSSR: isSsr };
};

export const HANDLERS = {
    [Types.FETCH_FRANCHISE_DATA_SUCCESS]: fetchDataSuccess,
    [Types.FETCH_FRANCHISE_DATA_FAILURE]: fetchDataFailure,
    [Types.SET_DETAILS]: setDetails,
    [Types.SET_IS_SSR]: setIsSsr
};

export default createReducer(INITIAL_STATE, HANDLERS);
